import { createSlice } from '@reduxjs/toolkit';
import { getDropdownSettingsApi } from '../../../rtk-apis/clinics/getDropdownSettings';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const getDropdownSettingsSlice = createSlice({
  name: 'getDropdownSettings',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getDropdownSettingsApi.pending, state => {
        state.loading = true;
      })
      .addCase(getDropdownSettingsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(getDropdownSettingsApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getDropdownSettingsSlice.reducer;
export const { clearState } = getDropdownSettingsSlice.actions;
